import Button from "react-bootstrap/Button";
import Header from "../components/Header";
import NavBar from "../components/NavBar";

import mockBanner from "../images/about-us/about-us-mock-banner.png";

import { FaRegLightbulb, FaLanguage, FaChalkboard } from "react-icons/fa6";

const AboutUs = () => {
  return (
    <div className="container-main">
      <NavBar/>
      <Header title="About Us" addClassName="abt-us-header" />
      <div
        className="abt-us-hero-container"
        style={{
          backgroundImage: "url(" + mockBanner + ")",
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: "33rem",
        }}
      >
        <h1 className="abt-us-hero-header">About Us</h1>
        <p className="abt-us-hero-text">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s, when an unknown printer took a galley of type and
          scrambled it to make a type specimen book.
        </p>
        <Button variant="custom-primary">
          <a href="/team">Meet our team</a>
        </Button>
      </div>

      <div className="abt-us-who-container">
        <h2 className="abt-us-who-header">WHO WE ARE</h2>
        <p className="abt-us-who-text">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </p>
      </div>

      <div className="abt-us-tri-blocks">
        <div className="abt-us-block abt-us-block--1">
          <div className="abt-us-block-header">
            <span className="vert-line"></span>
            <FaRegLightbulb className="abt-us-icon" style={{fontSize: "4em", top: "-0.5em", position: "relative"}}/>
            <h3>INNOVATIVE AND TAILORED CURRICULUM</h3>
          </div>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s.
        </div>
        <div className="abt-us-block abt-us-block--2">
          <div className="abt-us-block-header">
            <span className="vert-line"></span>
            <FaLanguage className="abt-us-icon" style={{fontSize: "3.5em", top: "-0.5em", position: "relative"}} />
            <h3>ACCESSIBLE FOR ALL</h3>
          </div>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s.
        </div>
        <div className="abt-us-block abt-us-block--3">
          <div className="abt-us-block-header">
            <span className="vert-line"></span>
            <FaChalkboard className="abt-us-icon" style={{fontSize: "6.5em", top: "-0.5em", position: "relative"}} />
            <h3>EXPERIENCED AND PASSIONATE TRAINERS</h3>
          </div>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s.
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
